import EventPageModal from './EventPageModal'

export default EventPageModal
